/**
 * Service wrapper for /api/artist-applications.
 * Used by ApplyArtistPage.
 */

async function authedFetch(path, token, options = {}) {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 20000);
  try {
    const res = await fetch(path, {
      ...options,
      signal: controller.signal,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        ...(options.headers || {}),
      },
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || data?.success === false) {
      throw new Error(data?.error || `Error ${res.status}`);
    }
    return data.data;
  } finally {
    clearTimeout(timeout);
  }
}

/**
 * Fetch the current user's latest application, or null if none.
 */
export const getMyArtistApplication = (token) =>
  authedFetch('/api/artist-applications', token);

/**
 * Submit a new artist application. The body uses the same camelCase
 * keys as the admin artist endpoints.
 */
export const createArtistApplication = (token, payload) =>
  authedFetch('/api/artist-applications', token, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
